import React from 'react';

export function injectProp (Component, extraProps) {
  return <Component.type {...Component.props} {...extraProps} />;
}

// String

String.prototype.i18nFormat = function () {
  return this.replace(/-/gi, '_').toUpperCase();
};

String.prototype.htmlToText = function () {
  return this.replace(/<[^>]*>?/gm, '');
};

String.prototype.normalizeString = function () {
  return this.replace(/_/g, ' ');
};

String.prototype.makeUrl = function () {
  return this.toLowerCase().split(' ').join('_');
};

export function nFormatter (num, digits) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1E3, symbol: 'k' },
    { value: 1E6, symbol: 'M' },
    { value: 1E9, symbol: 'G' },
    { value: 1E12, symbol: 'T' },
    { value: 1E15, symbol: 'P' },
    { value: 1E18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}

// Object

export function getKeyByValue (object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

// Array

export function cutArrayHalf (arr, part) {
  const list = [...arr];
  const half = Math.ceil(list.length / 2);
  const part1 = list.splice(0, half);
  const part2 = list.splice(-half);

  return part === 1 ? part1 : part2;
}

export const canUseDOM = !!(
  (typeof window !== 'undefined' &&
      window.document && window.document.createElement)
);

export function timeConvert (time) {
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) {
    time = time.slice(1);
    time[5] = +time[0] < 12 ? ' AM' : ' PM';
    time[0] = +time[0] % 12 || 12;
  }

  const timeWithZero = time.join('').replace(/^0(?:0)?/, '');
  const index = timeWithZero.indexOf(':');
  const lastDigs = timeWithZero.slice(index + 1, index + 3);
  return lastDigs === '00' ? timeWithZero.replace(':00', '') : timeWithZero;
}
